export default "__VITE_ASSET__Be1NOMw9__"